import vi from './vi.png'
import en from './en.png'

const getFlag = code => {
    switch (code){
        case 'en':
            return en 

        case 'vi':
            return vi

        default:
            return vi
    }
}

export default getFlag